import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "email--sprite",
  "use": "email--sprite-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"email--sprite\">\n<path d=\"M15.4168 4.00033C15.4168 3.26699 14.8168 2.66699 14.0835 2.66699H3.41683C2.6835 2.66699 2.0835 3.26699 2.0835 4.00033V12.0003C2.0835 12.7337 2.6835 13.3337 3.41683 13.3337H14.0835C14.8168 13.3337 15.4168 12.7337 15.4168 12.0003V4.00033ZM14.0835 4.00033L8.75016 7.33366L3.41683 4.00033H14.0835ZM14.0835 12.0003H3.41683V5.33366L8.75016 8.66699L14.0835 5.33366V12.0003Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol